module.exports = __webpack_public_path__ + "static/img/gazetaTopo1.99859ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/PMVG/gazetaTopo1.png
// module id = Z+Yt
// module chunks = 1